import axios from "axios";
import React, { useEffect, useState } from "react";
import "./addrole.scss";
import ModalUmum from "../../modal/modalUmum/ModalUmum";
import { useNavigate } from "react-router-dom";
import Loading from "../../components/loading/Loading";

function Addrole() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState();
  const [modalShow, setModalShow] = useState(false);
  const [title, setTitle] = useState();
  const [add, setAdd] = useState({
    category: "",
    role: "",
    description: "",
    menu: "",
    report: "",
  });

  const addRole = async () => {
    if (
      add.category !== "" &&
      add.role !== "" &&
      add.description !== "" &&
      add.menu !== "" &&
      add.report !== ""
    ) {
      setLoading(true);
      await axios.post("https://mobile.amospa.com/roles", add);
      setLoading(false);
      setTitle("Success Add Role");
      setModalShow(true);
    } else {
      setTitle("Isi Semua Form");
      setModalShow(true);
    }
  };

  //Handle Next
  const handleNext = async () => {
    setModalShow(false);
    navigate("/homepage/setting/role/");
  };

  return (
    <div>
      {loading ? (
        <Loading />
      ) : (
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="wrapper-add-role">
                <div className="header-add-role">
                  <h5 className="m-0">Create new role</h5>
                </div>
                <div className="form-add-role">
                  <div className="wrapper-data">
                    <label>
                      Category <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      name="category"
                      onChange={(e) =>
                        setAdd({ ...add, category: e.target.value })
                      }
                    />
                  </div>
                  <div className="wrapper-data">
                    <label>
                      Role <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      name="role"
                      onChange={(e) => setAdd({ ...add, role: e.target.value })}
                    />
                  </div>
                  <div className="wrapper-data">
                    <label>
                      Description <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      name="description"
                      onChange={(e) =>
                        setAdd({ ...add, description: e.target.value })
                      }
                    />
                  </div>
                  <div className="wrapper-data">
                    <label>
                      List Menu <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      name="menu"
                      onChange={(e) => setAdd({ ...add, menu: e.target.value })}
                    />
                  </div>
                  <div className="wrapper-data">
                    <label>
                      List Report <span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      name="report"
                      onChange={(e) =>
                        setAdd({ ...add, report: e.target.value })
                      }
                    />
                  </div>
                  <button className="text-white" onClick={() => addRole()}>
                    Create new role
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      <ModalUmum
        show={modalShow}
        onHide={() => setModalShow(false)}
        title={title}
        nextButton={
          title !== "Isi Semua Form" ? handleNext : () => setModalShow(false)
        }
      />
    </div>
  );
}

export default Addrole;
